<div class="opf-slot">
  <button type="button" class="op-filterbtn" (click)="opened = true; statusOpen = false">
    <i class="material-icons">filter_list</i> {{ constants.LABELS.FILTER }}
  </button>
  <div class="op-filter-backdrop" *ngIf="opened" (click)="opened = false"></div>
  <div class="op-filter-panel" *ngIf="opened">
    <div class="op-fp-head">{{ constants.LABELS.FILTER }}</div>
    <ng-container *ngIf="openForm" [ngSwitch]="trackByFormKey()">
      <form [formGroup]="filterForm">
        <div class="op-fp-row">
          <label class="op-fp-label">{{ constants.LABELS.NAME }}</label>
          <select class="op-fp-field" [formControlName]="constants.FORM_CONTROLS.SELECTED_NAME">
            <option [ngValue]="null">All</option>
            <option *ngFor="let o of name" [ngValue]="o.value">{{ o.label }}</option>
          </select>
        </div>
        <div class="op-fp-row">
          <label class="op-fp-label">{{ constants.LABELS.EXPERIENCE }}</label>
          <select class="op-fp-field" [formControlName]="constants.FORM_CONTROLS.SELECTED_EXPERIENCE">
            <option [ngValue]="null">All</option>
            <option *ngFor="let o of yearsOfExperience" [ngValue]="o.value">{{ o.label }}</option>
          </select>
        </div>
        <div class="op-fp-row" *ngIf="fieldsVisibility === personaType.hiringMgrCandidates">
          <label class="op-fp-label">{{ constants.LABELS.POSITION }}</label>
          <select class="op-fp-field" [formControlName]="constants.FORM_CONTROLS.SELECTED_POSITION">
            <option [ngValue]="null">All</option>
            <option *ngFor="let o of position" [ngValue]="o.value">{{ o.label }}</option>
          </select>
        </div>
        <div class="op-fp-row">
          <label class="op-fp-label">{{ constants.LABELS.LOCATION }}</label>
          <select class="op-fp-field" [formControlName]="constants.FORM_CONTROLS.SELECTED_LOCATION">
            <option [ngValue]="null">All</option>
            <option *ngFor="let o of locationOptions" [ngValue]="o.value">{{ o.label }}</option>
          </select>
        </div>
        <div class="op-fp-row" *ngIf="fieldsVisibility === personaType.OpsCandidates || fieldsVisibility === personaType.vendorCandidates">
          <label class="op-fp-label">{{ constants.LABELS.AVAILABLE_BY }}</label>
          <input type="date" class="op-fp-field" [formControlName]="constants.FORM_CONTROLS.SELECTED_AVAILABLE_BY" />
        </div>
        <div class="op-fp-row" *ngIf="fieldsVisibility === personaType.OpsCandidates || fieldsVisibility === personaType.vendorCandidates">
          <label class="op-fp-label">{{ constants.LABELS.DATE_APPLIED }}</label>
          <input type="date" class="op-fp-field" [formControlName]="constants.FORM_CONTROLS.SELECTED_DATE_APPLIED" />
        </div>
        <div class="op-fp-row" *ngIf="fieldsVisibility === personaType.OpsCandidates || fieldsVisibility === personaType.vendorCandidates">
          <label class="op-fp-label">{{ constants.LABELS.HIRING_MANAGER }}</label>
          <select class="op-fp-field" [formControlName]="constants.FORM_CONTROLS.SELECTED_HIRING_MANAGER">
            <option [ngValue]="null">All</option>
            <option *ngFor="let o of hiringManager" [ngValue]="o.value">{{ o.label }}</option>
          </select>
        </div>
        <div class="op-fp-row" *ngIf="fieldsVisibility === personaType.OpsCandidates">
          <label class="op-fp-label">{{ constants.LABELS.VENDOR }}</label>
          <select class="op-fp-field" [formControlName]="constants.FORM_CONTROLS.SELECTED_VENDOR">
            <option [ngValue]="null">All</option>
            <option *ngFor="let o of vendor" [ngValue]="o.value">{{ o.label }}</option>
          </select>
        </div>
        <div class="op-fp-row">
          <label class="op-fp-label">{{ constants.LABELS.STATUS }}</label>
          <div class="op-fp-msel">
            <button type="button" class="op-fp-field op-fp-msel-btn" (click)="statusOpen = !statusOpen">
              <span class="msel-text">{{ statusSummary }}</span>
              <i class="material-icons" [class.flip]="statusOpen">expand_more</i>
            </button>
            <div class="op-fp-msel-list" *ngIf="statusOpen">
              <label class="op-fp-check" *ngFor="let s of status">
                <input type="checkbox" [checked]="isStatusChecked(s.value)" (change)="toggleStatus(s.value)" />
                {{ s.label }}
              </label>
            </div>
          </div>
        </div>
      </form>
    </ng-container>
    <div class="op-fp-actions">
      <button type="button" class="op-fp-reset" (click)="statusOpen = false; reset()">{{ constants.LABELS.RESET }}</button>
      <button type="button" class="op-fp-apply" (click)="statusOpen = false; opened = false; apply()">{{ constants.LABELS.APPLY }}</button>
    </div>
  </div>
</div>
